import { PolicyType } from './policy';
export var ActionStatus;
(function (ActionStatus) {
    /** Ready to be processed, depending on action_on date */
    ActionStatus["PENDING"] = "pending";
    /** Processed */
    ActionStatus["COMPLETE"] = "complete";
    /** Failed */
    ActionStatus["FAILED"] = "failed";
    /** Like pending, but should not be automatically processed */
    ActionStatus["SUSPENDED"] = "suspended";
    /** When a late fee, or some other future action type? has been reverted */
    ActionStatus["REVERTED"] = "reverted";
    /** When the policy state was set to approval */
    ActionStatus["APPROVAL_PENDING"] = "approval_pending";
})(ActionStatus || (ActionStatus = {}));
/** When we want to treat reverted like completed, e.g calculating repeating */
export const completeLikeActionStatuses = [
    ActionStatus.COMPLETE,
    ActionStatus.REVERTED,
];
export var ActionType;
(function (ActionType) {
    ActionType["LATE_FEE"] = "late_fee";
    ActionType["LATE_FEE_EMAIL"] = "late_fee_email";
    ActionType["REMINDER"] = "reminder";
    ActionType["DISCOUNT_APPLY"] = "discount_apply";
    ActionType["DISCOUNT_REMOVE"] = "discount_remove";
    ActionType["DISCOUNT_APPLIED_EMAIL"] = "discount_applied_email";
    ActionType["DISCOUNT_REMOVED_EMAIL"] = "discount_removed_email";
    ActionType["SEND_SMS"] = "send_sms";
    /** Invoice based AI phone call */
    ActionType["AI_CALL_INVOICE"] = "ai_call_invoice";
    /** A job to check for any contact based late fees */
    ActionType["ISSUE_STATEMENT_LATE_FEE"] = "issue_statement_late_fee";
    /** Per Contact */
    ActionType["SEND_STATEMENT"] = "send_statement";
    ActionType["ESCALATION"] = "escalation";
    ActionType["SEND_STATEMENT_INTEREST_EMAIL"] = "send_statement_interest_email";
    ActionType["SEND_ANNOUNCEMENT"] = "send_announcement_email";
    /** Per Quote */
    ActionType["QUOTE_EMAIL"] = "quote_email";
    /** System */
    /** Queue up a disconnect action when no sub */
    ActionType["ORGANISATION_DISCONNECT"] = "organisation_disconnect";
    ActionType["SCHEDULED_MOPUP"] = "scheduled_mopup";
})(ActionType || (ActionType = {}));
export const emailTypes = [
    ActionType.DISCOUNT_APPLIED_EMAIL,
    ActionType.DISCOUNT_REMOVED_EMAIL,
    ActionType.LATE_FEE_EMAIL,
    ActionType.REMINDER,
    ActionType.SEND_STATEMENT,
    ActionType.SEND_STATEMENT_INTEREST_EMAIL,
    ActionType.SEND_ANNOUNCEMENT,
    ActionType.QUOTE_EMAIL,
];
/** Keeping this as a known list to keep it easy to find notes later */
export var ActionNotes;
(function (ActionNotes) {
    /** When a new invoice fallback was applied - locked */
    ActionNotes["NEW_LATE_FEE_INVOICE_DUE_TO_LOCKED"] = "NEW_LATE_FEE_INVOICE_DUE_TO_LOCKED";
    /** When a new invoice fallback was applied - part paid */
    ActionNotes["NEW_LATE_FEE_INVOICE_DUE_TO_PART_PAID"] = "NEW_LATE_FEE_INVOICE_DUE_TO_PART_PAID";
    /** When no outstanding balance on statement send */
    ActionNotes["NO_OUTSTANDING_BALANCE_SEND_STATEMENT"] = "NO_OUTSTANDING_BALANCE_SEND_STATEMENT";
    /** When no overdue balance, and policy set to overdue */
    ActionNotes["NO_OVERDUE_BALANCE_SEND_STATEMENT"] = "NO_OVERDUE_BALANCE_SEND_STATEMENT";
    /** Min balance not met */
    ActionNotes["MIN_DUE_BALANCE_NOT_MET_SEND_STATEMENT"] = "MIN_DUE_BALANCE_NOT_MET_SEND_STATEMENT";
    /** MIN age not met */
    ActionNotes["NO_OVERDUE_AFTER_MIN_AGE"] = "NO_OVERDUE_AFTER_MIN_AGE";
    /** When the action was trigger manually */
    ActionNotes["FORCED"] = "FORCED";
    /** We failed to mark as sent in accounting system */
    ActionNotes["FAILED_TO_MARK_SENT_EXTERNAL"] = "FAILED_TO_MARK_SENT_EXTERNAL";
    /** WHEN CHILD ACTIONS ARE MANUALLY RECREATED */
    ActionNotes["CHILD_ACTIONS_RECREATED"] = "CHILD_ACTIONS_RECREATED";
})(ActionNotes || (ActionNotes = {}));
export const actionNotesReadable = {
    [ActionNotes.NEW_LATE_FEE_INVOICE_DUE_TO_LOCKED]: `Late fee was issued as a new invoice due to the current invoice being in a locked period`,
    [ActionNotes.NEW_LATE_FEE_INVOICE_DUE_TO_PART_PAID]: `Late fee was issued as a new invoice due to payments or credit notes on the current invoice`,
    [ActionNotes.NO_OUTSTANDING_BALANCE_SEND_STATEMENT]: `No outstanding balance, so no statement was sent`,
    [ActionNotes.NO_OVERDUE_BALANCE_SEND_STATEMENT]: `No overdue balance for contact, so no statement was sent`,
    [ActionNotes.NO_OVERDUE_AFTER_MIN_AGE]: `No overdue balance for contact after applying a min debt age, so no statement was sent`,
    [ActionNotes.MIN_DUE_BALANCE_NOT_MET_SEND_STATEMENT]: `Minimum due balance not met, so no statement was sent`,
    [ActionNotes.FORCED]: `Action was manually processed early.`,
    [ActionNotes.FAILED_TO_MARK_SENT_EXTERNAL]: `Late fee email was sent successfully, but failed to mark as sent in accounting system`,
    [ActionNotes.CHILD_ACTIONS_RECREATED]: `This action was recreated manually`,
};
export const policyActionMap = new Map([
    [ActionType.LATE_FEE, PolicyType.LATE_FEE],
    [ActionType.REMINDER, PolicyType.REMINDER],
    [ActionType.SEND_SMS, PolicyType.SMS],
    [ActionType.AI_CALL_INVOICE, PolicyType.AI_CALL],
]);
export const actionSortMap = new Map([
    [`invoiceNumber`, `invoice_number`],
    [`type`, `type`],
    [`actionOn`, `action_on`],
    [`executedOn`, `executed_date`],
    [`status`, `status`],
]);
/** What the action is applied to */
export var ActionTargetResource;
(function (ActionTargetResource) {
    /** E.g Late fees per invoice */
    ActionTargetResource["INVOICE"] = "INVOICE";
    /** E.g Org Disconnect, Or statement check */
    ActionTargetResource["ORGANISATION"] = "ORGANISATION";
    /** Statements */
    ActionTargetResource["CONTACT"] = "CONTACT";
    ActionTargetResource["QUOTE"] = "QUOTE";
})(ActionTargetResource || (ActionTargetResource = {}));
/** All Require valid subscription be linked to be ran, except for ALWAYS */
export var PendingActionGroup;
(function (PendingActionGroup) {
    PendingActionGroup["NONE"] = "NONE";
    PendingActionGroup["LATE_FEE"] = "LATE_FEE";
    PendingActionGroup["LATE_FEE_EMAIL"] = "LATE_FEE_EMAIL";
    PendingActionGroup["NORMAL"] = "NORMAL";
    PendingActionGroup["ALWAYS"] = "ALWAYS";
})(PendingActionGroup || (PendingActionGroup = {}));
export const actionConfig = {
    [ActionType.REMINDER]: {
        originPolicyType: PolicyType.REMINDER,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        billableType: `email`,
        canActionNow: true,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        color: `#0269A1`,
    },
    [ActionType.SEND_SMS]: {
        originPolicyType: PolicyType.SMS,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        canRemoveOnFail: true,
        canActionNow: true,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        color: `#0F766E`,
    },
    [ActionType.LATE_FEE]: {
        originPolicyType: PolicyType.LATE_FEE,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        canActionNow: true,
        canRemoveOnFail: true,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.LATE_FEE,
        color: `#C2410D`,
    },
    [ActionType.LATE_FEE_EMAIL]: {
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: false,
        billableType: `email`,
        canActionNow: true,
        canRemovePending: true,
        pendingKickOffGroup: PendingActionGroup.LATE_FEE_EMAIL,
    },
    [ActionType.DISCOUNT_APPLIED_EMAIL]: {
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: false,
        canActionNow: true,
        billableType: `email`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
    },
    [ActionType.DISCOUNT_REMOVE]: {
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: false,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
    },
    [ActionType.DISCOUNT_APPLY]: {
        originPolicyType: PolicyType.DISCOUNT,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        color: `#7E23CE`,
    },
    [ActionType.DISCOUNT_REMOVED_EMAIL]: {
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: false,
        billableType: `email`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
    },
    [ActionType.ORGANISATION_DISCONNECT]: {
        targetResource: ActionTargetResource.ORGANISATION,
        includedInActionGeneration: false,
        pendingKickOffGroup: PendingActionGroup.ALWAYS,
    },
    [ActionType.SCHEDULED_MOPUP]: {
        targetResource: ActionTargetResource.ORGANISATION,
        includedInActionGeneration: false,
        pendingKickOffGroup: PendingActionGroup.ALWAYS,
    },
    [ActionType.ISSUE_STATEMENT_LATE_FEE]: {
        targetResource: ActionTargetResource.CONTACT,
        includedInActionGeneration: true,
        canActionNow: true,
        canRemoveOnFail: true,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.LATE_FEE,
        color: `#f7a809`,
    },
    [ActionType.SEND_STATEMENT]: {
        targetResource: ActionTargetResource.CONTACT,
        includedInActionGeneration: true,
        canActionNow: true,
        canRemoveOnFail: true,
        billableType: `email`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        color: `#6990f4`,
    },
    [ActionType.ESCALATION]: {
        originPolicyType: PolicyType.ESCALATION,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        canActionNow: true,
        canRemoveOnFail: true,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        color: `#f78c09`,
    },
    [ActionType.SEND_STATEMENT_INTEREST_EMAIL]: {
        targetResource: ActionTargetResource.CONTACT,
        includedInActionGeneration: false,
        billableType: `email`,
        canActionNow: true,
        pendingKickOffGroup: PendingActionGroup.LATE_FEE_EMAIL,
    },
    [ActionType.SEND_ANNOUNCEMENT]: {
        targetResource: ActionTargetResource.CONTACT,
        includedInActionGeneration: false,
        billableType: `email`,
        canActionNow: true,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
    },
    [ActionType.AI_CALL_INVOICE]: {
        originPolicyType: PolicyType.AI_CALL,
        targetResource: ActionTargetResource.INVOICE,
        includedInActionGeneration: true,
        billableType: `action`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        canActionNow: true,
        canRemoveOnFail: true,
    },
    [ActionType.QUOTE_EMAIL]: {
        originPolicyType: PolicyType.QUOTE_EMAIL,
        targetResource: ActionTargetResource.QUOTE,
        includedInActionGeneration: true,
        billableType: `email`,
        pendingKickOffGroup: PendingActionGroup.NORMAL,
        canActionNow: true,
        canRemoveOnFail: true,
    },
};
export const actionStatementTypes = [
    ActionType.ISSUE_STATEMENT_LATE_FEE,
    ActionType.SEND_STATEMENT,
];
export const generateActionTypes = Object.keys(actionConfig).filter(key => actionConfig[key].includedInActionGeneration);
//# sourceMappingURL=action.js.map